// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"673":"date-range-picker","786":"graph"}[chunkId] || chunkId) + "." + {"19":"77afc2e9","459":"71cadf34","673":"565b3ea5","786":"f8c93ec7"}[chunkId] + ".chunk.css";
};